/** Generator 右侧 demo 预览区 OSS resize 宽度（营销区等仍可用）。 */
export const DEMO_PREVIEW_POSTER_OSS_WIDTH = 1024;

/**
 * Generator 功能区右侧 demo 海报：使用 CDN 原图，去掉 OSS 缩略参数。
 * @param {string} url
 */
export function resolveGeneratorDemoPosterUrl(url) {
  const raw = String(url ?? '').trim();
  if (!raw || !/^https?:\/\//i.test(raw)) return raw;

  const hashIdx = raw.indexOf('#');
  const base = hashIdx >= 0 ? raw.slice(0, hashIdx) : raw;
  const hash = hashIdx >= 0 ? raw.slice(hashIdx) : '';
  const withoutResize = base
    .replace(/([?&])x-oss-process=image\/resize,w_\d+(&|$)/, (_, sep, tail) => (tail === '&' ? sep : ''))
    .replace(/[?&]$/, '');

  return `${withoutResize}${hash}`;
}

/** 营销落地页 Hero 预览图 OSS 宽度（首页本地 srcset） */
export const MARKETING_HERO_POSTER_OSS_WIDTH = 320;

/** 子页 Hero 自定义 CDN 海报（i18n `previewInitialUrl`）— 展示区域更大，需更高 OSS 宽度 */
export const MARKETING_HERO_CUSTOM_POSTER_OSS_WIDTH = 480;

/** 营销落地页 Trusted brands Logo OSS 宽度 */
export const MARKETING_TRUSTED_BRAND_OSS_WIDTH = 88;

const OSS_RESIZE_RE = /x-oss-process=image\/resize,w_\d+/;

/**
 * 为 OSS/CDN 预览图追加或替换 resize 参数；本地 `/media` 路径原样返回。
 * @param {string} url
 * @param {number} [width=1024]
 */
export function withDemoPreviewOssResize(url, width = DEMO_PREVIEW_POSTER_OSS_WIDTH) {
  const raw = String(url ?? "").trim();
  if (!raw || !/^https?:\/\//i.test(raw)) return raw;

  const param = `x-oss-process=image/resize,w_${width}`;
  const hashIdx = raw.indexOf("#");
  const base = hashIdx >= 0 ? raw.slice(0, hashIdx) : raw;
  const hash = hashIdx >= 0 ? raw.slice(hashIdx) : "";

  if (OSS_RESIZE_RE.test(base)) {
    return `${base.replace(OSS_RESIZE_RE, param)}${hash}`;
  }

  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}${param}${hash}`;
}

/** 将 srcset 中每个 URL 追加/替换 OSS resize（本地 `/media` 路径不变）。 */
export function withOssResizeSrcsetUrls(srcset, width = DEMO_PREVIEW_POSTER_OSS_WIDTH) {
  const raw = String(srcset ?? "").trim();
  if (!raw) return raw;
  return raw
    .split(",")
    .map((part) => {
      const segments = part.trim().split(/\s+/);
      const url = segments[0];
      const descriptor = segments.slice(1).join(" ");
      const nextUrl = withDemoPreviewOssResize(url, width);
      return descriptor ? `${nextUrl} ${descriptor}` : nextUrl;
    })
    .join(", ");
}
